/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AelRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Ael } from './ael.model';

@Injectable()
export class AelListBusinessService implements InitViewService {
  constructor(private aelRest: AelRestService, private gridLayoutService: GridLayoutService) {

  }

  initView(): any {
    return {
      gridLayout: this.gridLayoutService.get('eventLog'),
    };
  }

  findAllAsDataSource(filter: any, entityType?: string, entityId?: ID, eventTypeIds?: number[]): SlicedDataSource<Ael> {
    return this.aelRest.findAllAsDataSource(filter, entityType, entityId, eventTypeIds);
  }
}
